<template>
  <div>
    <div class="contentBody">
      <div class="contentBody__title">
        <span class="text">会員アカウント統合のお知らせ</span>
      </div>
      <div class="contentBody__section">
        <div class="u-mg-t-1">
          この度、AGARUTVと占いフェスの会員アカウントの統合をおこないました。<br>
          今後は1つの会員アカウントでどちらのサービスもご利用いただけます。<br>
          <br>
          それに伴い利用規約を変更いたしましたので、サービスをご利用いただくには利用規約への同意をお願いします。<br>
          <br>
          ※過去に同じメールアドレスで両サービスの会員登録をおこない、同じ登録項目に対して別の情報を登録している場合は、占いフェス側のアカウントに登録された情報が反映されています。<br>
          <div style="text-align:center">
            <a href="https://agaru.tv/terms-of-service" target="_blank">利用規約</a>
          </div>
        </div>
      </div>
    </div>
    <div class="contentFooter">
      <div class="u-flexRow">
          <button class="btn"
            data-color="brand"
            data-block="true"
            @click="switchSignIn()"
          >利用規約に同意してログイン</button>
      </div>
    </div>
  </div>
</template>
<script>
import login from './login'
export default {
  name: 'switch-form',
  mixins: [login],
  props: {
    reissueKey: String,
    nonce: String
  },
  data() {
    return {
      cpno: window.Laravel.cpno,
      token: window.Laravel.csrfToken
    }
  },
  methods: {
    switchSignIn() {
      this.switchLoginByReissueKey()
    }
  }
}</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/SwitchForm.vue